module.exports = __webpack_public_path__ + "img/open.e7317169.png";